import palette from "assets/theme/base/palette";
import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import { Collapse, Menu, MenuItem } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";
import { useMaterialUIController } from "context";
import { call } from "services/axiosService/core";
import * as Sentry from "@sentry/browser";
import ReactPlayer from "react-player";
import MaxuLogo from "assets/images/nav-logo.png";
import MDBox from "components/MDBox";
import Loader from "pages/loader/Loader";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import IconButton from "@mui/material/IconButton";
import ArrowDropUpTwoToneIcon from "@mui/icons-material/ArrowDropUpTwoTone";
import ArrowDropDownTwoToneIcon from "@mui/icons-material/ArrowDropDownTwoTone";
import ContentPlayerDialog from "examples/Dialog/ContentPlayerDialog";
import NoContent from "pages/NoContent";

const MyGamePlan = () => {
  const [controller] = useMaterialUIController();
  const { profile, persona } = controller;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [gamePlan, setGamePlan] = useState([]);
  const [previousGamePlan, setPreviousGamePlan] = useState([]);
  const [previousYearsGamePlan, setPreviousYearsGamePlan] = useState([]);
  const [yearIndex, setYearIndex] = useState(0);
  const [userMetricsData, setUserMetricsData] = useState(null);
  const [likedContent, setLikedContent] = useState([]);
  const [dislikedContent, setDislikedContent] = useState([]);
  const [savedContent, setSavedContent] = useState([]);
  const [viewedContent, setViewedContent] = useState([]);
  const [recommendedContent, setRecommendedContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noContent, setNoContent] = useState(false);
  const [content, setContent] = useState({});
  const [playContent, setPlayContent] = useState(false);
  const [hasCompletedAll, setHasCompletedAll] = useState(false);
  const [planType, setPlanType] = useState("myGamePlan");
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [week, setWeek] = useState(0);

  const congratulationAnimation = {
    hidden: { opacity: 1, scale: 1, y: "-50vh" },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 3, // Now the duration will be respected
        ease: "easeInOut", // Smooth in & out effect
      },
    },
  };

  useEffect(() => {
    getUserGamePlan();
    loadUserContentMetrics();
  }, [profile]);

  const getUserGamePlan = () => {
    call(`users/${profile.id}/gameplan`, "GET", {})
      .then((response) => {
        if (response.status === 200) {
          console.log("response", response);
          const data = response.data.game_plan;
          const latest_plan = response.data.game_plan[0];
          const previous_plan = response.data.previous_game_plan || [];
          const previous_years_plan = response.data.previous_years_game_plan || [];
          setPreviousYearsGamePlan(previous_years_plan);
          setPreviousGamePlan(previous_plan);
          setGamePlan(response.data.game_plan);
          setHasCompletedAll(latest_plan.content.length == latest_plan.watched_content.length);
          setLoading(false);
        } else if (response.status === 404) {
          setGamePlan([]);
          setNoContent(true);
          setLoading(false);
        } else if (response.status === 440) {
          setLoading(false);
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        setLoading(false);
        console.log(error);
      });
  };

  const loadUserContentMetrics = () => {
    call(`users/${profile.id}/contentmetrics`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          let data = res.data;
          setUserMetricsData(data);
          setLikedContent([...data.likedcontent]);
          setDislikedContent([...data.dislikedcontent]);
          setViewedContent([...data.viewedcontent]);
          setSavedContent([...data.savedcontent]);
          setRecommendedContent([...data.recommendedcontent]);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const likeHandler = (title) => {
    let eventkey = { event: "likecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentlikedContent.push(title);
    // if content in disliked array remove it from there
    if (currentdislikedContent.includes(title)) {
      const index = currentdislikedContent.indexOf(title);
      currentdislikedContent.splice(index, 1);
      eventkey = { event: "likecontent-removedislike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;

    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const dislikeHandler = (title) => {
    let eventkey = { event: "dislikecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentdislikedContent.push(title);
    // if content in liked array remove it from there
    if (currentlikedContent.includes(title)) {
      const index = currentlikedContent.indexOf(title);
      currentlikedContent.splice(index, 1);
      eventkey = { event: "dislikecontent-removelike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeLikeHandler = (title) => {
    let eventkey = { event: "removelikecontent", value: title };

    var currentlikedContent = [...likedContent];
    const index = currentlikedContent.indexOf(title);
    currentlikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeDislikeHandler = (title) => {
    let eventkey = { event: "removedislikecontent", value: title };
    var currentdislikedContent = [...dislikedContent];
    const index = currentdislikedContent.indexOf(title);
    currentdislikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const saveHandler = (title) => {
    let eventkey = { event: "savedcontent", value: title };
    let currentSavedContent = [...savedContent];
    let metricData = userMetricsData;
    if (currentSavedContent.includes(title)) {
      const index = currentSavedContent.indexOf(title);
      currentSavedContent.splice(index, 1);
      eventkey = { event: "removeSaved", value: title };
    } else {
      currentSavedContent.push(title);
    }
    metricData["savedcontent"] = [...currentSavedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setSavedContent([...currentSavedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const getHeadingForWeek = (week, t) => {
    if (week < 5) {
      // Weeks 1–4 (weekly)
      return t("gamePlan.weekContent", { range: week });
    } else if (week < 7) {
      // Weeks 5–6, 7–8 (biweekly)
      const start = 5 + (week - 5) * 2;
      const end = start + 1;
      return t("gamePlan.weekContent", { range: `${start}-${end}` });
    } else {
      // From week 9 onward (every 4 weeks)
      const start = 9 + (week - 7) * 4;
      const end = start + 3;
      return t("gamePlan.weekContent", { range: `${start}-${end}` });
    }
  };

  const getContentLinkHandler = (item, type, weekIndex) => {
    call(`content/${item.title}`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          setWeek(weekIndex);
          setPlanType(type);
          setPlayContent(true);
          setContent(res.data);
        }
      })
      .catch((err) => {
        console.log("error is", err);
        Sentry.captureException(err);
      });
  };

  const closeContentPlayer = () => {
    setPlayContent(false);
  };

  const selectedLabel = yearIndex === 0
    ? t("gamePlan.currentPlan", { defaultValue: "Current Plan" })
    : `${t("gamePlan.previousPlan", { defaultValue: "Previous Plan" })} ${yearIndex}`;

  return (
    <DashboardLayout>
      <DashboardNavbar title={t("pageTitles.myGamePlan")} />
      <MDBox mt={2} />

      {/* Plan selector dropdown */}
      <MDBox display="flex" justifyContent="flex-end" mb={4}>
        <MDBox
          onClick={(e) => setMenuAnchor(e.currentTarget)}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: "12px",
            border: `1.5px solid ${palette.neutral[300]}`,
            bgcolor: "#fff",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            transition: "all 180ms ease",
            "&:hover": { borderColor: palette.brand[400], bgcolor: palette.brand[50] },
          }}
        >
          <Icon sx={{ color: palette.brand[500], fontSize: "18px !important" }}>calendar_month</Icon>
          <MDTypography variant="button" fontWeight="medium" sx={{ color: "text.primary" }}>
            {selectedLabel}
          </MDTypography>
          <Icon sx={{ color: palette.neutral[500], fontSize: "18px !important" }}>keyboard_arrow_down</Icon>
        </MDBox>

        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={() => setMenuAnchor(null)}
          PaperProps={{
            sx: {
              mt: 1,
              borderRadius: "14px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
              minWidth: 200,
              overflow: "hidden",
            },
          }}
        >
          {/* Current Plan */}
          <MenuItem
            onClick={() => { setYearIndex(0); setMenuAnchor(null); }}
            sx={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              px: 2, py: 1.2,
              bgcolor: yearIndex === 0 ? palette.brand[50] : "transparent",
              "&:hover": { bgcolor: palette.brand[50] },
            }}
          >
            <MDBox display="flex" alignItems="center" gap={1}>
              <Icon sx={{ color: palette.brand[500], fontSize: "16px !important" }}>calendar_month</Icon>
              <MDTypography variant="button" fontWeight={yearIndex === 0 ? "bold" : "regular"} sx={{ color: "text.primary" }}>
                {t("gamePlan.currentPlan", { defaultValue: "Current Plan" })}
              </MDTypography>
            </MDBox>
            {yearIndex === 0 && <Icon sx={{ color: palette.brand[500], fontSize: "16px !important" }}>check_circle</Icon>}
          </MenuItem>

          {/* Previous Plans */}
          {previousYearsGamePlan.map((_, i) => (
            <MenuItem
              key={i}
              onClick={() => { setYearIndex(i + 1); setMenuAnchor(null); }}
              sx={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                px: 2, py: 1.2,
                bgcolor: yearIndex === i + 1 ? palette.brand[50] : "transparent",
                "&:hover": { bgcolor: palette.brand[50] },
              }}
            >
              <MDBox display="flex" alignItems="center" gap={1}>
                <Icon sx={{ color: palette.neutral[500], fontSize: "16px !important" }}>history</Icon>
                <MDTypography variant="button" fontWeight={yearIndex === i + 1 ? "bold" : "regular"} sx={{ color: "text.primary" }}>
                  {`${t("gamePlan.previousPlan", { defaultValue: "Previous Plan" })} ${i + 1}`}
                </MDTypography>
              </MDBox>
              {yearIndex === i + 1 && <Icon sx={{ color: palette.brand[500], fontSize: "16px !important" }}>check_circle</Icon>}
            </MenuItem>
          ))}
        </Menu>
      </MDBox>

      {yearIndex == 0 ? (
        <>
          <Grid container spacing={3}>
            {gamePlan?.length > 0 && (
              <GamePlanCard
                gamePlanType="myGamePlan"
                weekIndex={0}
                plan={gamePlan[0]}
                likedContent={likedContent}
                dislikedContent={dislikedContent}
                savedContent={savedContent}
                viewedContent={viewedContent}
                handlers={{
                  likeHandler,
                  dislikeHandler,
                  removeLikeHandler,
                  removeDislikeHandler,
                  saveHandler,
                  getContentLinkHandler,
                }}
                heading={getHeadingForWeek(gamePlan[0].week, t)}
                t={t}
              />
            )}
          </Grid>

          {hasCompletedAll && (
            <Grid item xs={12} sx={{ mb: 2 }}>
              <motion.div initial="hidden" animate="visible" variants={congratulationAnimation}>
              <Card
                sx={{
                  borderRadius: "20px",
                  border: "1.5px solid rgba(0,0,0,0.08)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  overflow: "hidden",
                }}
              >
                <MDBox display="flex" alignItems="center" gap={3} p={3}>
                  {/* Snow globe illustration — 30% width */}
                  <MDBox
                    sx={{
                      flexShrink: 0,
                      width: "30%",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      py: 2,
                    }}
                  >
                    {/* Sparkles */}
                    <MDBox sx={{ position: "absolute", top: 4, left: "8%", color: palette.brand[400], fontSize: "22px", lineHeight: 1 }}>✦</MDBox>
                    <MDBox sx={{ position: "absolute", top: 16, left: "2%", color: "#fdd835", fontSize: "13px", lineHeight: 1 }}>✦</MDBox>
                    <MDBox sx={{ position: "absolute", top: 8, right: "6%", color: "#f48326", fontSize: "13px", lineHeight: 1 }}>●</MDBox>
                    <MDBox sx={{ position: "absolute", bottom: "22%", left: "4%", color: palette.brand[500], fontSize: "11px", lineHeight: 1 }}>●</MDBox>
                    <MDBox sx={{ position: "absolute", bottom: "18%", right: "4%", color: "#9c27b0", fontSize: "10px", lineHeight: 1 }}>●</MDBox>
                    <MDBox sx={{ position: "absolute", top: "28%", right: "2%", color: palette.brand[300], fontSize: "18px", lineHeight: 1 }}>✦</MDBox>

                    {/* Globe body */}
                    <MDBox
                      sx={{
                        width: "40%",
                        paddingBottom: "40%",
                        position: "relative",
                        borderRadius: "50%",
                        background: "radial-gradient(circle at 38% 32%, rgba(255,255,255,0.95), rgba(220,240,230,0.85))",
                        border: "3px solid rgba(200,230,210,0.9)",
                        boxShadow: "0 8px 32px rgba(76,175,80,0.18), inset 0 -6px 16px rgba(0,0,0,0.06)",
                      }}
                    >
                      <MDBox
                        sx={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <MDBox
                          sx={{
                            width: "55%",
                            height: "55%",
                            borderRadius: "50%",
                            bgcolor: "#4caf50",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 4px 14px rgba(76,175,80,0.4)",
                          }}
                        >
                          <Icon sx={{ color: "#fff", fontSize: "clamp(20px, 3vw, 36px) !important" }}>check</Icon>
                        </MDBox>
                      </MDBox>
                    </MDBox>

                    {/* Globe base stem */}
                    <MDBox sx={{ width: "20%", height: 12, bgcolor: "#c8e6c9", borderRadius: "2px", mt: "-1px" }} />
                    {/* Globe base */}
                    <MDBox sx={{ width: "40%", height: 12, bgcolor: "#a5d6a7", borderRadius: "8px" }} />
                  </MDBox>

                  {/* Text + Buttons */}
                  <MDBox flex={1}>
                     <MDTypography variant="h5" fontWeight="bold" color="primary" textAlign= "center">
                    🎉 {t("gamePlan.congratulations")}! 🎉
                  </MDTypography>
                    <MDTypography variant="h6" fontWeight="bold" sx={{ color: "text.primary", mb: 0.5, textAlign: "center" }}>
                      {t("gamePlan.completedAllContentMessage")}
                    </MDTypography>
                    <MDTypography variant="body2" sx={{ color: "text.primary", mb: 0.25,textAlign: "center"  }}>
                      {t("gamePlan.lookingForMoreContent")}
                    </MDTypography>
                    <MDTypography variant="body2" sx={{ color: "text.secondary", mb: 2,  textAlign: "center" }}>
                      {t("gamePlan.askMaxwell")}
                    </MDTypography>

                    <MDButton
                      onClick={() => navigate("/dashboard", { state: { openBot: true } })}
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ borderRadius: "10px", mb: 1, py: 1.2, fontWeight: 700, letterSpacing: "0.06em" }}
                    >
                      {t("gamePlan.chatWithMaxwell")}
                    </MDButton>

                    <MDButton
                      onClick={() => navigate("/contentlibrary")}
                      variant="outlined"
                      color="primary"
                      fullWidth
                      sx={{ borderRadius: "10px", py: 1.2, fontWeight: 700, letterSpacing: "0.06em" }}
                    >
                      {t("gamePlan.visitContentLibrary")}
                    </MDButton>
                  </MDBox>
                </MDBox>
              </Card>
              </motion.div>
            </Grid>
          )}

          <Grid container spacing={3}>
            {previousGamePlan?.length > 0 &&
              previousGamePlan.map((planItem, index) => (
                <GamePlanCard
                  key={index}
                  gamePlanType="previousGamePlan"
                  weekIndex={index}
                  plan={planItem}
                  likedContent={likedContent}
                  dislikedContent={dislikedContent}
                  savedContent={savedContent}
                  viewedContent={viewedContent}
                  handlers={{
                    likeHandler,
                    dislikeHandler,
                    removeLikeHandler,
                    removeDislikeHandler,
                    saveHandler,
                    getContentLinkHandler,
                  }}
                  heading={getHeadingForWeek(planItem.week, t)}
                  t={t}
                />
              ))}
          </Grid>
        </>
      ) : (
        <Grid container spacing={3}>
          {previousYearsGamePlan[yearIndex - 1].map((planItem, index) => (
            <GamePlanCard
              key={index}
              gamePlanType="previousYearsGamePlan"
              weekIndex={index}
              plan={planItem}
              likedContent={likedContent}
              dislikedContent={dislikedContent}
              savedContent={savedContent}
              viewedContent={viewedContent}
              handlers={{
                likeHandler,
                dislikeHandler,
                removeLikeHandler,
                removeDislikeHandler,
                saveHandler,
                getContentLinkHandler,
              }}
              heading={getHeadingForWeek(planItem.week, t)}
              t={t}
            />
          ))}
        </Grid>
      )}

      {playContent && (
        <ContentPlayerDialog
          playContent={playContent}
          gamePlan={gamePlan}
          setGamePlan={setGamePlan}
          previousGamePlan={previousGamePlan}
          setPreviousGamePlan={setPreviousGamePlan}
          previousYearsGamePlan={previousYearsGamePlan}
          setPreviousYearsGamePlan={setPreviousYearsGamePlan}
          closeContentPlayer={closeContentPlayer}
          content={content}
          userMetricsData={userMetricsData}
          setUserMetricData={setUserMetricsData}
          setViewedContent={setViewedContent}
          setHasCompletedAll={setHasCompletedAll}
          userId={profile.id}
          week={week}
          planType={planType}
          yearIndex={yearIndex}
          t={t}
        />
      )}

      {noContent && (
        <NoContent
          title={t("playList.noContentAvailable")}
          subtitle={t("playList.contactSupport")}
          icon="event_note"
          iconColor="#ff9800"
        />
      )}

      {loading && (
        <Dialog open={loading} fullScreen>
          <DialogContent>
            <Loader loaderText={t("loaderText.loadingGamePlan")} />
          </DialogContent>
        </Dialog>
      )}
    </DashboardLayout>
  );
};

export default MyGamePlan;

const GamePlanCard = ({
  gamePlanType,
  weekIndex,
  plan,
  likedContent,
  dislikedContent,
  savedContent,
  viewedContent,
  handlers,
  heading,
  t,
}) => {
  const totalItems = plan.content.length;
  const viewedItems = plan.watched_content.length;
  const progressPercentage = totalItems > 0 ? Math.round((viewedItems / totalItems) * 100) : 0;
  const isCompleted = progressPercentage >= 100;
  const [collapsed, setCollapsed] = useState(isCompleted);
  if (!Array.isArray(plan.content)) return null;
  const {
    likeHandler,
    dislikeHandler,
    removeLikeHandler,
    removeDislikeHandler,
    saveHandler,
    getContentLinkHandler,
  } = handlers;

  return (
    <Grid item xs={12} sx={{ mb: 3 }}>
      <Card
        sx={{
          borderRadius: "20px",
          border: "1.5px solid rgba(0,0,0,0.08)",
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
          overflow: "hidden",
          backgroundColor: "#fff",
        }}
      >
        {/* ── Header ── */}
        <MDBox
          px={3}
          py={2.5}
          display="flex"
          alignItems="center"
          gap={2}
          sx={{ cursor: "pointer" }}
          onClick={() => setCollapsed(!collapsed)}
        >
          {/* Calendar icon circle */}
          <MDBox
            sx={{
              bgcolor: palette.brand[50],
              borderRadius: "12px",
              width: 44,
              height: 44,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Icon sx={{ color: palette.brand[500], fontSize: "22px !important" }}>calendar_month</Icon>
          </MDBox>

          <MDTypography variant="h5" fontWeight="bold" sx={{ color: "text.primary", flexGrow: 1 }}>
            {heading}
          </MDTypography>

          <MDBox display="flex" alignItems="center" gap={1}>
            {/* Status badge */}
            {isCompleted ? (
              <MDBox
                sx={{
                  display: "flex", alignItems: "center", gap: 0.5,
                  bgcolor: palette.orange[50], border: `1.5px solid ${palette.orange[200]}`,
                  borderRadius: "20px", px: 1.5, py: 0.5,
                }}
              >
                <Icon sx={{ color: palette.orange[500], fontSize: "16px !important" }}>check_circle</Icon>
                <MDTypography variant="caption" fontWeight="bold" sx={{ color: palette.orange[500] }}>
                  {t("contentCard.completed", { defaultValue: "Completed" })}
                </MDTypography>
              </MDBox>
            ) : progressPercentage > 0 ? (
              <MDBox
                sx={{
                  display: "flex", alignItems: "center", gap: 0.5,
                  bgcolor: palette.brand[50], border: `1.5px solid ${palette.brand[100]}`,
                  borderRadius: "20px", px: 1.5, py: 0.5,
                }}
              >
                <Icon sx={{ color: palette.brand[500], fontSize: "16px !important" }}>timelapse</Icon>
                <MDTypography variant="caption" fontWeight="bold" sx={{ color: palette.brand[600] }}>
                  {t("contentCard.inProgress", { defaultValue: "In Progress" })}
                </MDTypography>
              </MDBox>
            ) : (
              <MDBox
                sx={{
                  display: "flex", alignItems: "center", gap: 0.5,
                  bgcolor: palette.neutral[100], border: `1.5px solid ${palette.neutral[300]}`,
                  borderRadius: "20px", px: 1.5, py: 0.5,
                }}
              >
                <Icon sx={{ color: palette.neutral[500], fontSize: "16px !important" }}>schedule</Icon>
                <MDTypography variant="caption" fontWeight="bold" sx={{ color: palette.neutral[600] }}>
                  {t("contentCard.notStarted", { defaultValue: "Not Started" })}
                </MDTypography>
              </MDBox>
            )}

            {/* Collapse toggle */}
            <MDBox
              sx={{
                bgcolor: palette.neutral[100],
                border: `1.5px solid ${palette.neutral[200]}`,
                borderRadius: "10px",
                width: 36,
                height: 36,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 180ms ease",
                "&:hover": { bgcolor: palette.neutral[200] },
              }}
            >
              <Icon sx={{ color: palette.neutral[600], fontSize: "22px !important" }}>
                {collapsed ? "keyboard_arrow_down" : "keyboard_arrow_up"}
              </Icon>
            </MDBox>
          </MDBox>
        </MDBox>

        <Collapse in={!collapsed} timeout="auto" unmountOnExit>
          {/* ── Progress bar ── */}
          <MDBox px={3} pb={2.5}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <MDTypography variant="body2" sx={{ color: "text.secondary" }}>
                <strong style={{ color: palette.brand[600] }}>{viewedItems}</strong>
                {` of ${totalItems} contents viewed`}
              </MDTypography>
              <MDTypography variant="body2" fontWeight="bold" sx={{ color: palette.orange[500] }}>
                {progressPercentage}% Complete
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                height: 8,
                borderRadius: 4,
                bgcolor: palette.neutral[300],
                overflow: "hidden",
                position: "relative",
              }}
            >
              <MDBox
                sx={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: `${progressPercentage}%`,
                  bgcolor: palette.orange[500],
                  borderRadius: 4,
                  transition: "width 0.4s ease",
                }}
              />
            </MDBox>
          </MDBox>

          {/* ── Content Cards ── */}
          <Grid container spacing={3} px={3} pb={3}>
            {plan.content.map((item, index) => {
              let icon = "movie";
              const type = item.content_type.toLowerCase();
              if (type === "infographic") icon = "leaderboard";
              else if (type === "article") icon = "article";
              else if (type === "worksheet") icon = "note";

              const isViewed = plan.watched_content.includes(item.title);

              return (
                <Grid item xs={12} md={4} key={item.id || index}>
                  <DefaultProjectCard
                    item={item}
                    icon={icon}
                    type={item.content_type}
                    title={item.title}
                    content_url={item.content_url}
                    image={item.thumbnail_url || MaxuLogo}
                    getContentLinkHandler={getContentLinkHandler}
                    shareable={false}
                    liked={likedContent.includes(item.title)}
                    disliked={dislikedContent.includes(item.title)}
                    saved={savedContent.includes(item.title)}
                    viewed={false}
                    likeHandler={likeHandler}
                    dislikeHandler={dislikeHandler}
                    removeLikeHandler={removeLikeHandler}
                    removeDislikeHandler={removeDislikeHandler}
                    saveHandler={saveHandler}
                    showTypeLabel={false}
                    viewedChip={isViewed}
                    action={{
                      type: "external",
                      route: item.content_url,
                      color: "info",
                      label: t("buttonTitles.view"),
                    }}
                    gamePlanType={gamePlanType}
                    weekIndex={weekIndex}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Collapse>
      </Card>
    </Grid>
  );
};
